document.addEventListener("DOMContentLoaded", function () {
    updateFloatingCart();
    document.addEventListener("cart:updated", updateFloatingCart);
    document.addEventListener("cart:refresh", updateFloatingCart);
    document.body.addEventListener("click", function (e) {
        const btn = e.target.closest("#floating-cart-open-drawer");
        if (!btn) return;
        e.preventDefault();
        const drawer = document.querySelector("m-cart-drawer");
        if (drawer && typeof drawer.open === "function") {
            drawer.open(document.querySelector(".m-cart-icon-bubble"));
        } else {
            const headerCart = document.querySelector(".m-cart-icon-bubble");
            if (headerCart) {
                headerCart.click();
            }
        }
    });

});

function updateFloatingCart() {

    fetch("/cart.js")
        .then(response => response.json())
        .then(cart => {

            const bar = document.getElementById("floating-cart-bar");
            const thumbs = document.getElementById("floating-cart-thumbnails");
            const total = document.getElementById("floating-cart-total");
            const count = document.getElementById("floating-cart-count");

            if (!bar) return;

            if (cart.item_count === 0) {
                bar.classList.remove("active");
                return;
            }

            bar.classList.add("active");

            count.textContent =
                cart.item_count + (cart.item_count > 1 ? " Items" : " Item");

            total.textContent =
                "₹" + (cart.total_price / 100).toLocaleString("en-IN");

            thumbs.innerHTML = "";

            cart.items.slice(0, 3).forEach(function (item) {

                let image = "";

                if (item.featured_image && item.featured_image.url) {
                    image = item.featured_image.url;
                } else if (item.image) {
                    image = item.image;
                }

                thumbs.insertAdjacentHTML(
                    "beforeend",
                    `
                    <div class="floating-cart-thumb">
                        <img
                            src="${image}"
                            alt="${item.product_title}"
                            loading="lazy">
                    </div>
                    `
                );

            });

        })
        .catch(function (error) {
            console.log("Floating Cart Error:", error);
        });

}